import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'

export default function BilerTilSalg() {
  const [pageData, setPage] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // Set metadata
    document.title = "Biler til salg - Frejlev Auto v/ Jacob Kvist"
    const metaDesc = document.querySelector('meta[name="description"]')
    if (metaDesc) {
      metaDesc.setAttribute('content', "Se vores udvalg af biler til salg hos Frejlev Auto v/ Jacob Kvist i Aalborg SV.")
    }

    // Fetch page content from CMS
    fetch('https://api.dev.auxo.dk/public/by-slug/da/biler-til-salg')
      .then(res => res.json())
      .then(data => {
        setPage(data)
        setLoading(false)
      })
      .catch(err => {
        console.error('Error fetching biler til salg page:', err)
        setLoading(false)
      })
  }, [])

  return (
    <div className="min-h-screen bg-gray-50 py-12 md:py-20 text-gray-900">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Breadcrumbs */}
        <div className="text-xs text-gray-500 uppercase tracking-wider mb-6 flex items-center gap-2">
          <span>Forside</span>
          <i className="fa-solid fa-chevron-right text-[8px]"></i>
          <span className="text-[#5cbe4f] font-semibold">Biler til salg</span>
        </div>

        {loading ? (
          <div className="space-y-6 animate-pulse">
            <div className="h-10 bg-gray-200 rounded w-3/4"></div>
            <div className="h-6 bg-gray-200 rounded w-1/2"></div>
            <div className="h-40 bg-gray-200 rounded"></div>
          </div>
        ) : pageData ? (
          <article className="space-y-10 bg-white p-6 sm:p-10 rounded-2xl border border-gray-200 shadow-sm">
            {/* Header */}
            <div className="space-y-3">
              <h1 className="text-3xl sm:text-4xl md:text-5xl font-black text-gray-950 tracking-tight">
                {pageData.title.split('|')[0].trim()}
              </h1>
              <div className="h-1 w-20 bg-[#5cbe4f] rounded"></div>
            </div>

            {/* Description */}
            <div 
              className="rich-text"
              dangerouslySetInnerHTML={{ 
                __html: pageData.content.replace(/<h1[^>]*>.*?<\/h1>/i, '') 
              }}
            />

            {/* Contact CTA */}
            <div className="pt-6 border-t border-gray-200 flex flex-wrap items-center justify-between gap-4">
              <p className="text-sm text-gray-600">
                Interesseret i en bil eller har du spørgsmål? Kontakt os direkte.
              </p>
              <Link
                to="/kontakt-frejlev-auto"
                className="bg-[#5cbe4f] hover:bg-[#4ca83e] text-white text-xs font-bold px-6 py-3 rounded-lg uppercase tracking-wider transition-all shadow-md shadow-[#5cbe4f]/20"
              >
                Kontakt os
              </Link>
            </div>
          </article>
        ) : (
          <div className="text-center py-12">
            <p className="text-gray-500">Kunne ikke indlæse indholdet. Prøv igen senere.</p>
          </div>
        )}
      </div>
    </div>
  )
}
